import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import Modal from 'antd/es/modal';
import Input from 'antd/es/input';
import Checkbox from 'antd/es/checkbox';
import message from 'antd/es/message';
import {MedPassCard} from '../../components/module_components/medpass';
import {
  closeMedPassPopup,
  getMedPassList,
  paymentHandler,
  showHideSubscriptionPopup,
} from '../../redux/actions/Subscription';
import {client} from '../../apollo/apolloClient';
import {INITIATE_MONTHLY_PAYMENT} from '../../apollo/schema';

class PopupSubscriptionPre extends Component {

  state = {
    id: '',
    checked: true,
  };

  componentDidMount() {
    this.props.getMedPassList();
  }

  getOrderId = () => {
    const {checked, id} = this.state;
    const {paymentHandler, closeMedPassPopup} = this.props;
    client.query({
      query: INITIATE_MONTHLY_PAYMENT,
      variables: {
        id,
        redeemWithWallet: checked,
      },
    }).then(res => {
      if (res.errors !== undefined && res.errors.length > 0) {
        message.error('Something went wrong. Please try again');
      } else if (res.data.initiatePayment.medpassActive) {
        this.setState({
          modalVisible: false,
        }, () => closeMedPassPopup(true));
      } else {
        this.setState({
          modalVisible: false,
        }, () => {
          paymentHandler(res.data.initiatePayment.orderId, id,
              false);
        });
      }
    }).catch(() => {
      message.error('Something went wrong');
    });
  };

  initiatePaymentMethod = (id, subscriptionType) => {
    const {checked} = this.state;
    const {paymentHandler, closeMedPassPopup} = this.props;
    this.props.showHideSubscriptionPopup(false);

    client.query({
      query: INITIATE_MONTHLY_PAYMENT,
      variables: {
        id,
        redeemWithWallet: checked,
      },
    }).then(res => {
      if (res.errors !== undefined && res.errors.length > 0) {
        message.error('Something went wrong. Please try again');
      } else if (res.data.initiatePayment.medpassActive) {
        this.setState({
          modalVisible: false,
          subscriptionType,
        }, () => closeMedPassPopup(true));
      } else {
        this.setState({
          modalVisible: false,
          subscriptionType,
        }, () => {
          paymentHandler(res.data.initiatePayment.orderId, id,
              false);
        });
      }
    }).catch(() => {
      message.error('Something went wrong');
    });
  };

  handleOrderSelection = (id, subscriptionType, price) => {
    this.props.showHideSubscriptionPopup(false);
    this.setState({
      modalVisible: true,
      selectedPrice: price,
      id,
      subscriptionType,
    });
  };

  redirectToSubscription = () => {
    const {history, showHideSubscriptionPopup} = this.props;
    showHideSubscriptionPopup({popup: false, text: ''});
    history.push('/medpass/');
  };

  handleUseWallet = () => {
    this.setState(state => ({
      checked: !state.checked,
    }));
  };

  handleMedPassPopupCancel = () => {
    this.props.closeMedPassPopup(false);
    window.location.reload();
  };

  handleSubscriptionPopupCancel = () => {
    this.props.showHideSubscriptionPopup({popup: false, text: ''});
  };

  handlePayPopupCancel = () => {
    this.setState({
      modalVisible: false,
    });
  };

  handleBuyNow = (id, subscriptionType, offerPrice) => {
    const {cash} = this.props.util.walletData;
    if (cash > 0) {
      this.handleOrderSelection(id, subscriptionType, offerPrice);
    } else {
      this.initiatePaymentMethod(id, subscriptionType);
    }
  };

  render() {
    const {subscription: {medPassList, showSubscriptionPopup, showMedPassPopup, subscriptionText}, util: {walletData: {cash}}} = this.props;
    const {modalVisible, selectedPrice, checked} = this.state;

    const buildMedPasses = () => {
      let slides = [];
      Object.values(medPassList).forEach((data, index) => {
        const passesCount = data.length;
        if (passesCount > 0) {
          const tempData = passesCount === 1 ?
              data :
              data.sort((
                  {numberOfSubs: nextNumberOfSubs},
                  {numberOfSubs: currentNumberOfSubs}) => nextNumberOfSubs -
                  currentNumberOfSubs);
          slides.push(
              <Col span={24} key={index} className="text-center">
                <MedPassCard
                    data={tempData}
                    passesCount={passesCount}
                    passIndex={index}
                    onBuy={this.handleBuyNow}
                    mini
                />
              </Col>,
          );
        }
      });
      return slides;
    };

    return (
        <>
          <Modal
              visible={showMedPassPopup}
              title={null}
              footer={null}
              centered
              width={350}
              onCancel={this.handleMedPassPopupCancel}
              className="checkout-confirm-modal"
          >
            <img
                className="responsive-image"
                src="https://assets-new.medcampus.io/assets/images/medpass-pop-up.png"
                alt="medpass_member"
                onClick={this.handleMedPassPopupCancel}
            />
          </Modal>
          <Modal
              visible={modalVisible}
              width={500}
              centered
              onOk={this.getOrderId}
              onCancel={this.handlePayPopupCancel}
              keyboard={false}
              maskClosable={false}
              okText="Proceed"
              cancelText="Cancel"
          >
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Row type="flex">
                  <Checkbox
                      checked={checked} className="checkbox"
                      onClick={this.handleUseWallet}
                  />
                  <p className="mc-ml-5">Use wallet money</p>
                </Row>
                <Input
                    size="large"
                    value={checked ? Math.min(cash, selectedPrice) : 0}
                    maxLength={60}
                    disabled={true}
                />
              </Col>
              <Col xs={24} sm={12}>
                <Row>
                  <Col span={6}>
                    <p>You Pay</p>
                  </Col>
                </Row>
                <Input
                    size="large"
                    value={checked ?
                        Math.max(selectedPrice - cash, 0) :
                        selectedPrice}
                    maxLength={60}
                    disabled={true}
                />
              </Col>
            </Row>
          </Modal>
          <Modal
              visible={showSubscriptionPopup}
              width={500}
              footer={null}
              centered
              onCancel={this.handleSubscriptionPopupCancel}
          >
            <Row>
              <Col span={24} className="text-center">
                <h1><b>Get MedPass</b></h1>
                <p>{subscriptionText}</p>
                <p className="mc-blue-text pointer text-center"
                   onClick={this.redirectToSubscription}>(Learn more)</p>
              </Col>
              <Col span={24}>
                {buildMedPasses()}
              </Col>
            </Row>
          </Modal>
        </>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const PopupSubscription = withRouter(
    connect(
        mapStateToProps,
        {
          getMedPassList,
          showHideSubscriptionPopup,
          paymentHandler,
          closeMedPassPopup,
        },
    )(PopupSubscriptionPre),
);

export {PopupSubscription};
